<template>
  <div>
    <div class="d-flex align-items-center">
      <span class="mr-1">
        <b>{{ badgeTitle }}:</b>
      </span>
      <span v-if="customer.membership">{{ getMembershipDates() }}</span>
      <span v-else> Not Available </span>
    </div>
    <CustomerMembershipModal
      v-if="editMembership"
      :membership="customer.membership"
      @save-success="$emit('save-success')"
      @hide-modal="toggleModal"
    />
  </div>
</template>

<script>
import CustomerMembershipModal from "@/MembershipModal/CustomerMembershipModal.vue";
export default {
  components: {
    CustomerMembershipModal
  },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  emits: ["save-success"],
  data() {
    return {
      editMembership: false
    };
  },
  computed: {
    badgeTitle() {
      return this.customer.membership
        ? this.customer.membership.membership_program_name
        : "Membership";
    }
  },
  methods: {
    getMembershipDates() {
      if (this.customer.membership.active) {
        return `${this.shortDate(this.customer.membership.starts_at)} -
        ${this.shortDate(
          this.customer.membership.ends_at || this.customer.membership.renews_at
        )}`;
      }
      return "Expired";
    },
    toggleModal() {
      this.editMembership = !this.editMembership;
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-divider {
  border-bottom: 1px solid var(--gray-border-color);
  width: 100%;
  margin: 2px 0;
}
</style>
